import { type Actions, ActionType } from './tailored-widgets.actions';
import { initialState, type State, tailoredWidgetsAdapter } from './tailored-widgets.state';

export function tailoredWidgetsReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.RESET: {
            return { ...initialState };
        }
        case ActionType.FETCH_TAILORED_WIDGETS: {
            return { ...state, isPending: true };
        }
        case ActionType.FETCH_TAILORED_WIDGETS_SUCCEEDED: {
            return tailoredWidgetsAdapter.setAll(action.payload.tailoredWidgets, { ...state, isLoaded: true, isPending: false });
        }
        case ActionType.FETCH_TAILORED_WIDGETS_FAILED: {
            return { ...state, error: action.payload.error, isLoaded: false, isPending: false };
        }
        default: {
            return state;
        }
    }
}
